export enum DomId {
  ApplicationHeader = 'applicationHeader',
  TablePagination = 'tablePagination',
  SearchHeaderArea = 'searchHeaderArea',
  HelpTop = 'top',
  HelpAdvancedSearch = 'help-advanced-search',
  HelpAvailability = 'help-availability',
  HelpCustomizingViews = 'help-customizing-views',
  HelpGeneralPDP = 'help-general-pdp',
  HelpGeneralPLP = 'help-general-plp',
  HelpImages = 'help-images',
  HelpMultiItemSearch = 'help-multi-item-search',
  HelpSources = 'help-sources',
}
